@if (title()) {
    <h5>{{title()}}</h5>
}
<div class="view-container">
    <div class="code-block" 
        [class.none]="indent()==='none'"
        [class.small]="indent()==='small'"
        [class.medium]="indent()==='medium'"
        [class.large]="indent()==='large'"
    >
        <code #content>
<ng-content></ng-content>
        </code>
    </div>
    <button (click)="copy()" [class.blink]="blinking()"><span class="bi bi-copy"></span></button>
</div>
